import * as React from 'react';
import {withRouter, PlainRoute} from 'react-router';
import {connect} from 'react-redux';
import * as _ from 'lodash';
/**
 *  This function should never be used for render, only for helpers when direct store access is needed.
 */
export function adjustLocationInStore(state) {
    return {...state, routing: {...state.routing, location: state.routing.locationBeforeTransitions}};
}

export function getStateWithRouting(state, props) {
    const {location} = props;
    return {...state, routing: {location}};
}

const getEnhancedWrappedComponent = <Props extends {routes?: PlainRoute[], [prop: string]: any}>(WrappedComponent) =>  {
    class EnhancedWrappedComponent extends React.Component<Props> {
        private matchedRoute: any;
        componentDidMount() {
            this.matchedRoute = _.last(this.props.routes);
        }
        shouldComponentUpdate(nextProps) {
          if (nextProps.overrideLocationProtection) { // TODO - @@EP for re-authentication
            return true;
          }
          return this.matchedRoute === _.last(nextProps.routes);
        }
        render() {
            return <WrappedComponent {..._.omit(this.props, 'overrideLocationProtection')}/>;
        }
    }
    return EnhancedWrappedComponent;
};

export default function connectWithRouter(mapStateToProps = undefined, mapDispatchToProps = undefined, {overrideLocationProtection} = {overrideLocationProtection: false}) {
    return <Props extends {routes?: PlainRoute[], [prop: string]: any}>(WrappedComponent) => {
        const innerComponent = mapStateToProps ? connect((state, ownProps, ...mapStateToPropsArgs) => {
            const stateWithRouting = getStateWithRouting(state, ownProps);
            return {overrideLocationProtection, ...mapStateToProps(stateWithRouting, ownProps, ...mapStateToPropsArgs)};
        }, mapDispatchToProps)(getEnhancedWrappedComponent<Props>(WrappedComponent)) : WrappedComponent;
        return withRouter(innerComponent);
    };
}